<div class="currency-page">
  <h1>Currency rates</h1>

  @if (loading()) {
    <stena-skeleton-loader type="text" [rows]="3" />
  } @else {
    <form [formGroup]="headerForm" class="controls">
      <stena-select
        class="dense-3"
        formControlName="mode"
        label="Mode"
        [options]="modeOptions"
      />
      <stena-select
        class="dense-3"
        formControlName="monthId"
        [label]="selectLabel()"
        [options]="monthOptions()"
      />
    </form>

    @if (selectedMonthId() === null) {
      <p class="hint">
        Select a {{ mode() === 'budget' ? 'fiscal year' : 'month' }} to edit
        rates.
      </p>
    } @else if (loadingRates()) {
      <stena-skeleton-loader type="text" [rows]="4" />
    } @else {
      <section class="rates">
        @for (
          row of rowsArray.controls;
          track row.controls.currencyId.value;
          let i = $index
        ) {
          <div class="rate-row" [formGroup]="row">
            <span class="currency-name"
              >{{ row.controls.currencyName.value }} =</span
            >
            <div class="rate-field">
              <label
                class="rate-label"
                [attr.for]="'sek-' + row.controls.currencyId.value"
                >TSEK</label
              >
              <input
                [id]="'sek-' + row.controls.currencyId.value"
                class="rate-input"
                type="number"
                step="0.0001"
                formControlName="rateSEK"
              />
            </div>
            <div class="rate-field">
              <label
                class="rate-label"
                [attr.for]="'eur-' + row.controls.currencyId.value"
                >TEUR</label
              >
              <input
                [id]="'eur-' + row.controls.currencyId.value"
                class="rate-input"
                type="number"
                step="0.0001"
                formControlName="rateEUR"
              />
            </div>
            <stena-button
              type="stroked"
              color="primary"
              text="Save"
              [disabled]="saving()"
              (buttonClick)="onSaveRow(row)"
            />
          </div>
        }
      </section>
    }
  }
</div>
